import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { JourneySectionService } from './journey-section.service';

@Component({
  selector: 'app-journey-section',
  standalone: true,
  imports: [NgFor, RevealOnScrollDirective],
  templateUrl: './journey-section.component.html',
  styleUrl: './journey-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JourneySectionComponent {
  get content() {
    return this.journeyService.content;
  }

  constructor(private readonly journeyService: JourneySectionService) {}
}
